import { createContext } from 'react'

import type { DueDateInput } from '@/shared/lib/due-date'

import type { Locale } from './locale'
import type { TranslateVars } from './translate'

/** Lo que toda la interfaz consume. Un solo objeto para no repartir el locale a mano. */
export interface I18n {
  /** El idioma efectivo de quien está mirando. */
  locale: Locale
  /**
   * El texto de `key`, con sus variables.
   *
   * Si la entrada tiene formas plurales, `vars.count` decide cuál sale, con las
   * reglas de CLDR (`Intl.PluralRules`), nunca con un ternario.
   */
  t: (key: string, vars?: TranslateVars) => string
  /** `18/09/2026` / `09/18/2026`. */
  formatDate: (value: DueDateInput, timeZone?: string) => string
  /** `17 sep 2026` / `Sep 17, 2026`. */
  formatDateMedium: (value: DueDateInput, timeZone?: string) => string
  formatDateTime: (value: DueDateInput, timeZone?: string) => string
  formatNumber: (value: number, options?: Intl.NumberFormatOptions) => string
  formatRelative: (value: DueDateInput, now?: Date) => string
  formatList: (items: readonly string[]) => string
}

/**
 * `null` cuando nadie montó el provider.
 *
 * `useI18n` cae al idioma por defecto en vez de tirar: un componente suelto en
 * un test o en un storybook tiene que poder dibujarse, y una pantalla en
 * español es mejor resultado que una excepción.
 */
export const I18nContext = createContext<I18n | null>(null)
